import { LicensePlateInput } from '../../../Components/Index';

const normalizePlate = value => String(value || '')
  .replace(/[۰-۹]/g, digit => '۰۱۲۳۴۵۶۷۸۹'.indexOf(digit))
  .replace(/[٠-٩]/g, digit => '٠١٢٣٤٥٦٧٨٩'.indexOf(digit))
  .replace(/ایران/g, '')
  .replace(/[\s|-]/g, '');

export const isCompletePlate = value => /^\d{2}[^\d]\d{5}$/.test(normalizePlate(value));

export default function PlateSearchField({ value, onChange }) {
  const complete = isCompletePlate(value);

  return <div className="service-one-plate-search">
    <div className="service-one-plate-search__head">
      <span>پلاک خودرو</span>
      {value && <small className={complete ? 'is-complete' : ''}>{complete ? 'آماده جستجو' : 'پلاک را کامل کنید'}</small>}
    </div>
    <LicensePlateInput value={value} onChange={onChange} />
  </div>;
}
